// extracted by mini-css-extract-plugin
module.exports = {"odd":"Statuses_odd__1bK15","empty":"Statuses_empty__2vHkk","statuses":"Statuses_statuses__1l0fm","count":"Statuses_count__1oGjD"};